<template>
  <div />
</template>

<script>
export default {
  name: 'TheHeader'
};
</script>
